import { optionById } from '@/features/data-hub/constants/exportOptions';

/**
 * Single source of truth for whether a data-export format has been chosen, shared by the
 * Format field (to know when to clear its own error) and the data-export footer (to know
 * whether to gate the export action) so the two can't drift apart.
 */
export const isDataExportOptionSelected = (previewOptionId: string | null): boolean =>
  previewOptionId !== null && optionById.has(previewOptionId);
